// extracted by mini-css-extract-plugin
module.exports = {"formHeader":"WeightagePage_formHeader__rWBfr","tab":"WeightagePage_tab__3ER0v","tabpanel":"WeightagePage_tabpanel__nYZK6"};